import { c as _c } from "react/compiler-runtime";
import { PortableText, type PortableTextBlock, type PortableTextComponents } from "next-sanity";
type RichTextProps<T extends PortableTextBlock = PortableTextBlock> = {
  data: T[];
  components?: PortableTextComponents;
};
export const RichText = t0 => {
  const $ = _c(3);
  const {
    data,
    components
  } = t0;
  let t1;
  if ($[0] !== components || $[1] !== data) {
    t1 = <PortableText value={data} components={components} onMissingComponent={false} />;
    $[0] = components;
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};